import React, { FC, HTMLAttributes } from 'react';
import styles from './Icon.module.scss';
import { IconSizes, IconNames, IconTypes } from '@/components/UI/Types';
const sizes = {
  xSmall: 14,
  small: 16,
  medium: 18,
  large: 20,
  xLarge: 22
};
interface IconPropsType extends HTMLAttributes<HTMLSpanElement> {
  name: IconNames;
  type: IconTypes;
  size?: IconSizes;
  data_cy?: string;
  className?: string;
}
const Icon: FC<IconPropsType> = ({
  type,
  size = 'medium',
  name,
  data_cy,
  className = '',
  ...props
}) => {
  const iconSize = (sizes[size] ?? size) + 'px';
  return <span className={`${styles[type]} ${type} icon-${name} ${className}`} style={{
    fontSize: iconSize
  }} data-cy={data_cy} {...props} data-sentry-component="Icon" data-sentry-source-file="Icon.tsx" />;
};
export default Icon;